import { useSelector, useDispatch } from "react-redux"
import AlertMessage from "./AlertMessage"
import { clearAlert } from "../../store/slices/alertSlice"

export default function GlobalAlert() {

  const dispatch = useDispatch()
  const { message, type } = useSelector(state => state.alert)

  if (!message) return null

  return (
    <AlertMessage
      message={message}
      type={type}
      onClose={() => dispatch(clearAlert())}
    />
  )

}